import { render, staticRenderFns } from "./DatatableSearchProjects.vue?vue&type=template&id=521ed90e&"
import script from "./DatatableSearchProjects.vue?vue&type=script&lang=js&"
export * from "./DatatableSearchProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('521ed90e')) {
      api.createRecord('521ed90e', component.options)
    } else {
      api.reload('521ed90e', component.options)
    }
    module.hot.accept("./DatatableSearchProjects.vue?vue&type=template&id=521ed90e&", function () {
      api.rerender('521ed90e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Configurations/Widgets/DatatableSearchProjects.vue"
export default component.exports